import React from 'react';
import Select from 'react-select';

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: '12px',
    borderColor: state.isFocused ? '#3b82f6' : '#e5e7eb',
    padding: '0 4px',
    boxShadow: state.isFocused ? '0 0 0 4px rgba(59, 130, 246, 0.1)' : 'none',
    border: state.isFocused ? '1px solid #3b82f6' : '1px solid #e5e7eb',
    outline: 'none',
    minHeight: '42px',
    fontSize: '14px',
    backgroundColor: '#fff',
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
    },
  }),
  valueContainer: provided => ({
    ...provided,
    padding: '0 8px',
  }),
  input: provided => ({
    ...provided,
    margin: '0',
    padding: '0',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#eff6ff' : '#fff',
    color: state.isSelected ? '#fff' : '#374151',
    padding: '10px 12px',
    fontSize: '14px',
    cursor: 'pointer',
    activeBackgroundColor: '#2563eb',
    ':active': {
      backgroundColor: state.isSelected ? '#2563eb' : '#dbeafe',
    },
  }),
  singleValue: provided => ({
    ...provided,
    color: '#111827',
  }),
  menu: provided => ({
    ...provided,
    borderRadius: '12px',
    boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
    border: '1px solid #f3f4f6',
    marginTop: '6px',
    overflow: 'hidden',
    zIndex: 9999,
  }),
  multiValue: provided => ({
    ...provided,
    backgroundColor: '#eff6ff',
    borderRadius: '6px',
    border: '1px solid #dbeafe',
  }),
  multiValueLabel: provided => ({
    ...provided,
    color: '#1e40af',
    fontWeight: '500',
    fontSize: '12px',
  }),
  multiValueRemove: provided => ({
    ...provided,
    color: '#3b82f6',
    borderRadius: '0 6px 6px 0',
    ':hover': {
      backgroundColor: '#dbeafe',
      color: '#1e40af',
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: provided => ({
    ...provided,
    color: '#9ca3af',
    ':hover': {
      color: '#6b7280',
    },
  }),
};

const CustomSelect = ({
  label,
  error,
  options,
  value,
  setSelectedValues,
  register = () => { },
  name,
  isDisabled = false,
  className = '',
  mb = true,
  isMulti = true,
  loading,
  dataCy,
  ...props
}) => {
  const handleChange = selectedOption => {
    if (!isMulti) {
      setSelectedValues(selectedOption?.value ?? '');
      return;
    }
    setSelectedValues(
      selectedOption ? selectedOption.map(option => option.value) : []
    );
  };

  return (
    <div className={`${mb && 'mb-5'} w-full ${className}`} data-cy={dataCy}>
      {label && (
        <label className='mb-[8px] block text-[16px] font-medium text-[#272A31]'>
          {label}
        </label>
      )}

      <Select
        options={options}
        isMulti={isMulti}
        value={value}
        onChange={handleChange}
        isDisabled={isDisabled}
        styles={customStyles}
        isLoading={loading}
        classNamePrefix='sportona-select'
        className='flex-1 border-none bg-transparent outline-none disabled:cursor-not-allowed disabled:opacity-30'
        {...props}
      />
      <input
        type='hidden'
        value={
          isMulti
            ? value?.map(option => option?.value ?? option).join(',') // For multi-select
            : value?.value ?? value ?? '' // For single-select
        }
        {...register(name)}
      />

      {error && <p className='mt-2 text-sm text-red-600'>{error}</p>}
    </div>
  );
};

export default CustomSelect;
